import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AngularMaterialModule } from './shared/angular-material/angular-material.module';
import { PipsModule } from './shared/pips/pips.module';
import { SharedModule } from './shared/components/shared.module';
import { ErrorHandlingInterceptor } from './interceptors/errorHandling.interceptor';
import { PortalModule } from '@angular/cdk/portal';
import { ToastrModule } from 'ngx-toastr';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { ApmErrorHandler, ApmModule, ApmService } from '@elastic/apm-rum-angular'
import { CountUpModule } from 'ngx-countup';
import { LayoutModule } from './features/layout/layout.module';
import { SeoModule } from './services/seo/seo.module';
import { LyImageCropperModule } from '@alyle/ui/image-cropper';
import { LY_THEME, LY_THEME_NAME, StyleRenderer, LyTheme2 } from '@alyle/ui';
import { MinimaDark } from '@alyle/ui/themes/minima';
import { JwtTokenInterceptor } from './interceptors/jwt-token.interceptor';
import { environment } from 'src/environments/environment';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  declarations: [	
    AppComponent,
  ],
  imports: [
    MatTooltipModule,
    ApmModule,  
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    BrowserAnimationsModule,
    AppRoutingModule,
    AngularMaterialModule,
    HttpClientModule,
    PipsModule,
    SharedModule,
    SharedModule.forRoot(),
    PortalModule,
    LayoutModule,
    CountUpModule,
    SeoModule.forRoot({siteName: 'آفرینه'}),
    NgxSkeletonLoaderModule.forRoot(),
    ToastrModule.forRoot({
      timeOut:3000,
      positionClass: 'toast-bottom-center',
      preventDuplicates: true,
      progressBar:false,
      progressAnimation:'decreasing',
      enableHtml:true,
      maxOpened:3,
      newestOnTop:true
    }),
    LyImageCropperModule,
  ],
  providers: [
    {provide: HTTP_INTERCEPTORS,useClass: ErrorHandlingInterceptor,multi:true},
    {provide: HTTP_INTERCEPTORS,useClass: JwtTokenInterceptor,multi:true},
    ApmService,
    {
      provide: ErrorHandler,
      useClass: ApmErrorHandler
    },
    StyleRenderer, LyTheme2, { provide: LY_THEME_NAME, useValue: 'minima-dark' }, { provide: LY_THEME, useClass: MinimaDark, multi: true }
  ],
  exports: [],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(service: ApmService) {
    var serviceName = "";
    if(environment.production && environment.mode.prod) {
      serviceName = 'roshdima-front-main';
    }
    if(environment.production && environment.mode.dev) {
      serviceName = 'roshdima-front-dev';
    }
    // if(serviceName != ""){
    //   const apm = service.init({
    //     serviceName: serviceName,
    //     serverUrl: 'https://apm.noarino.ir'
    //   })
    //   apm.setUserContext({
    //     'username': 'abbas',
    //     'id': '3254'
    //   })
    // }
  }
}